module.exports = __webpack_public_path__ + "img/jeonpo_detail.3487041f.jpg";